import { render, staticRenderFns } from "./InvoicesIndex.vue?vue&type=template&id=1e4b23a2"
import script from "./InvoicesIndex.vue?vue&type=script&lang=js"
export * from "./InvoicesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports